<template>
	<div class="home" >
		<div class="container p-l-r-0 container-shadow">
			<div class="row">
				<UserProfile :nameUpdate="nameToheader"></UserProfile>
			</div>
			<div class="row content-holder">
	            <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left">
	               <div class="col dashboard-left-menu ">
	                  <ul>
	                     <li class="tour_step_2"><a href="javascript://" class="active"><span class="text">Overview</span></a></li>
	                     <div class="tour_step_3">
	                        <li><a href="javascript://" class=""><span class="text">Business Set-up</span></a></li>
	                        <li><a href="javascript://" class=""><span class="text">Accounting Services</span></a></li>
	                        <li><a href="javascript://" class=""><span class="text">Ask an Expert</span></a></li>
	                     </div>
	                     <li class="tour_step_4"><a href="javascript://" class=""><span class="text">Grievances</span></a></li>
	                     <li class="tour_step_5"><a href="javascript://" class=""><span class="text">Billing</span></a></li>
	                     <li class="tour_step_6"><a href="javascript://" class=""><span class="text">Call Details</span></a></li>
	                  </ul>
	               </div>
	            </div>

	            <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right">
	               <div class="container" style="margin-top: 20px; font-size: 13px !important;">
	                  <div class="row data-list">
	                     <div class="col-sm-6 left">
	                        <div class="form-check"><label for="service-check" class="form-check-label"><span class="service_status"> Status : <span>Active</span></span></label></div>
	                        <div class="services-list"><p class="date"><span>Date:</span> 9-Jun--20xx  </p><p><span>Service:</span> Accounting Service - ( 120 Transactions, 10 Employees ) </p></div>
	                        <div><a href="javascript://" class="gobtn">Invoice</a><a href="javascript://" class="gobtn">More</a><!----></div>
	                     </div>
	                     <div class="col-sm-6 right">
	                        <ul><li><a href="javascript://"><span class="chat">Chat : 1</span></a></li>
	                           <li><a href="javascript://"><span class="files">Files: 0 </span></a></li>
	                           <li><a href="javascript://"><span class="summanry_milestone">Summary: 4</span></a></li>
	                        </ul>
	                     </div>
	                  </div>

	                  <div class="row data-list">
	                     <div class="col-sm-6 left">
	                        <div class="form-check"><label for="service-check" class="form-check-label"><span class="service_status"> Status : <span>Active</span></span></label></div>
	                        <div class="services-list"><p class="date"><span>Date:</span>  16-Feb--20xx  </p><p><span>Service:</span> Business Set-up - Private Limited Company (Pvt Ltd)  </p></div>
	                        <div><a href="javascript://" class="gobtn">Invoice</a><a href="javascript://" class="gobtn">More</a><!----></div>
	                     </div>
	                     <div class="col-sm-6 right">
	                        <ul><li><a href="javascript://"><span class="chat">Chat : 1</span></a></li>
	                           <li><a href="javascript://"><span class="files">Files: 0 </span></a></li>
	                           <li><a href="javascript://"><span class="summanry_milestone">Summary: 4</span></a></li>
	                        </ul>
	                     </div>
	                  </div>
	                  <div class="row data-list">
	                     <div class="col-sm-6 left">
	                        <div class="form-check"><label for="service-check" class="form-check-label"><span class="service_status"> Status : <span>Active</span></span></label></div>
	                        <div class="services-list"><p class="date"><span>Date:</span> 19-May--20xx   </p><p><span>Service:</span>  Accounting Service - ( 100 Transactions, 10 Employees ) </p></div>
	                        <div><a href="javascript://" class="gobtn">Invoice</a><a href="javascript://" class="gobtn">More</a><!----></div>
	                     </div>
	                     <div class="col-sm-6 right">
	                        <ul><li><a href="javascript://"><span class="chat">Chat : 1</span></a></li>
	                           <li><a href="javascript://"><span class="files">Files: 0 </span></a></li>
	                           <li><a href="javascript://"><span class="summanry_milestone">Summary: 4</span></a></li>
	                        </ul>
	                     </div>
	                  </div>
	               </div>
	            </div>
	         </div>
		</div>
		<div class="chat-button tour_step_7">
			<img src="../../assets/chat-icon.png">
         	<!-- <img src="images/chat.png"> -->
         	<span> 0</span>
      	</div>
	</div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/intro.js/2.9.3/intro.js" type="text/javascript"></script>
<script>
// @ is an alias to /src
import UserProfile from "../layouts/profile-header.vue"
import "intro.js/minified/introjs.min.css";
import TourDetails from '../../services/tour';
import { mapGetters } from 'vuex'
export default {
	name: 'user_profile',
	data(){
		return {
		list:{},
			isProfile: true,
			isBilling: false,
			connectionStatus:'',
			nameToheader:''
		}
		
	},
	components: {
		UserProfile
	},
	computed:{
		...mapGetters('user', {
			userList: 'list',
		})
	},
	methods:{
		tourUpdate(){
			
		}	
	},
	  mounted() {
        setTimeout(function(){
            const introJS = require("intro.js");
            introJS.introJs().setOptions({
				exitOnOverlayClick: false,
              exitOnEsc: false,
              keyboardNavigation: false,
              disableInteraction: true,
			  skipLabel:" x ",
              nextLabel: " Next",
              prevLabel: " Back ",
				steps: [
					{
					
					title: 'Farewell!',
					intro: '<p style="color: #000">Hi there!</p>Welcome to your personalised dashboard. Take a quick tour with us to explore its numerous features. '
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_2'),
					intro: 'Get a comprehensive view of all your services.',
					position: 'right'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_3'),
					intro: 'Check for a detailed view of individual services.',
					position: 'right'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_4'),
					intro: 'Raise a complaint or clarify your queries',
					position: 'right'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_5'),
					intro: 'Check your billing details',
					position: 'right'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_6'),
					intro: 'Check your call details',
					position: 'right'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_7'),
					intro: 'Start a quick chat with your accounting manager',
					position: 'top'
					},
					{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_8'),
					intro: 'Get on a call or schedule a call with your Accounting Manager',
					position: 'left',
					tooltipClass: 'customClose'
					},{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_9'),
					intro: 'Personalise your profile',
					position: 'bottom-right-aligned'
					}
					,{
					title: 'Farewell!',
					element: document.querySelector('.tour_step_10'),
					intro: 'Explore the website',
					position: 'bottom-middle-aligned',
					
					}
				]
				})
				.oncomplete(function() {
					TourDetails.post({'is_tour':1})
                    .then(res=>{
					   window.location.replace("/");
                    })
                    .catch(err=>{console.log(err)});
				
				})
				.onexit(function () {
					TourDetails.post({'is_tour':1})
                    .then(res=>{
					   window.location.replace("/");
                    })
                    .catch(err=>{console.log(err)});
				}).start();
        },800)
    },
	created(){
	}
};
</script>
<style scoped>
@import '../../../assets/css/tour.css';
</style>